/**
 * /influencer-platforms — primary route for feature `influencer-platforms`.
 *
 * Mounts the existing `InfluencerPlatformsPage` from
 * `@/features/influencer-platforms/`. Satisfies dash-contract-check rule
 * D1 (route file at `routes/<slug>.tsx`) for the slug. A parallel
 * `/influencers/platforms` namespaced route exists and shares the same
 * feature page; both routes render the same functionality so operators
 * have a stable primary URL at `/influencer-platforms`.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { InfluencerPlatformsPage } from "@/features/influencer-platforms/InfluencerPlatformsPage";

export const influencerPlatformsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/influencer-platforms",
	component: InfluencerPlatformsRoutePage,
});

export default influencerPlatformsRoute;

function InfluencerPlatformsRoutePage() {
	return (
		<main className="mx-auto flex w-full max-w-5xl flex-col gap-8 px-6 py-10">
			<header className="flex flex-col gap-2">
				<p className="text-xs font-semibold uppercase tracking-[0.12em] text-zinc-500">
					Influencer tracking
				</p>
				<h1 className="text-green-700 font-semibold text-3xl tracking-tight">
					Platform links per influencer
				</h1>
			</header>
			<InfluencerPlatformsPage />
		</main>
	);
}
